import { memo, useEffect } from 'react';

import { type UserCompanyNotificationDto, getUserCompanyNotificationById } from '@/services/ws-comments/src/main/resources/rest-api';
import { fromDateTimeType } from '@/js/libs/api-helpers';
import type { ModalState } from '@/js/libs/hooks/useModalState';
import { useSubscribe } from '@/js/libs/observable';
import { Label, Loader, Modal, RichTextEditor } from '@/js/libs/ui/src/V2';
import { NotActive, useRequest } from '@/js/libs/use-request';

import DateTime from 'src/components/DateTime/index.tsx';

type SystemNotificationModalProps = {
  state: ModalState<UserCompanyNotificationDto>;
  onRead: (id: string) => void;
};

export const SystemNotificationModal = memo(function SystemNotificationModal({ state, onRead }: SystemNotificationModalProps) {
  const { title, id, isRead, startDate } = state.payload ?? {};

  const notificationRequest = useRequest({
    apiMethod: getUserCompanyNotificationById,
    params: id ? { id } : NotActive,
  });

  const notificationBody = useSubscribe(notificationRequest.data$, (result) => result?.data?.message ?? '');
  const notificationPending = useSubscribe(notificationRequest.pending$);

  useEffect(() => {
    if (!isRead && id) {
      onRead(id);
    }
  }, [isRead, id, onRead]);

  return state.isMounted ? (
    <Modal state={state} title={title}>
      <Modal.Body>
        {notificationPending && <Loader cover />}
        <Label>
          <DateTime value={fromDateTimeType(startDate)} showLocal />
        </Label>
        <RichTextEditor allowImages value={notificationPending ? '' : notificationBody} readOnly readOnlyMode='content' />
      </Modal.Body>
    </Modal>
  ) : null;
});
